import React from 'react'
import DropdownMenu from './DropdownMenu'
import NoCannedReplies from './NoCannedReplies'

class Controller extends React.Component {
  state = {
    focusedCategory: null,
    focusedReply: null,
    mouseX: null,
    mouseY: null,
    categoryStateHeight: null,
  }

  componentDidMount() {
    const { fetchCannedReplyCategories } = this.props
    fetchCannedReplyCategories()
  }

  componentDidUpdate() {
    const { isLoadingCategories, searchTerm } = this.props
    if (!isLoadingCategories && searchTerm !== this.lastSearchTerm) {
      this.lastSearchTerm = searchTerm
      this.hasFocusedTemplate = false
      this.focusFirstItem()
    }
  }

  lastSearchTerm = null

  handleItemSelect = item => {
    const {
      toggleCollapedStateForCategories,
      ticketId,
      selectReply,
      fetchCannedReplies,
      searchTerm,
    } = this.props

    // If someone hits enter on a empty search result
    // or while searching
    if (!item) return null
    if (item.type === 'category') {
      if (!item.loaded && !item.loading)
        fetchCannedReplies([item.id], searchTerm)
      return toggleCollapedStateForCategories([item.id])
    }
    return selectReply(ticketId, item)
  }

  checkMouseMoved = evt => {
    const x = evt.clientX
    const y = evt.clientY
    const mouseMoved = x !== this.state.mouseX && y !== this.state.mouseY
    if (mouseMoved) {
      this.setState({ mouseX: x, mouseY: y })
      return true
    }

    return false
  }

  checkAndFocus = (newState, focusedViaMouse = false, evt) => {
    if (focusedViaMouse) {
      // Dont focus this item if the mouse didnt move (i.e. a scroll event
      // caused the onMouseOver to fire)
      if (!this.checkMouseMoved(evt)) return
    }
    this.setState({ ...newState, focusedViaMouse })
  }

  focusItem = (item, focusedViaMouse = false, evt = null) => {
    const { focusedId } = this.state
    if (item && item.id !== focusedId) {
      this.checkAndFocus({ focusedId: item.id }, focusedViaMouse, evt)
    }
  }

  focusFirstItem = () => {
    const { items } = this.props
    if (items && items.length > 0) this.focusItem(items[0])
  }

  focusedItem = () => {
    const { items } = this.props
    const { focusedId } = this.state
    const focusedItem = items.find(i => i.id === focusedId)
    return focusedItem
  }

  render() {
    const {
      items,
      isLoadingCategories,
      hasLoadedCategories,
      searchTerm,
      hideModal,
    } = this.props
    const { focusedViaMouse } = this.state

    return (
      <DropdownMenu
        autoScroll={!focusedViaMouse}
        focusedItem={this.focusedItem()}
        focusedItemIcon="keyboard-return"
        isLoadingItems={isLoadingCategories}
        hasLoadedItems={hasLoadedCategories}
        items={items}
        onItemFocus={this.focusItem}
        onItemSelect={this.handleItemSelect}
        emptyPlaceholder={<NoCannedReplies onClick={hideModal} />}
        searchTerm={searchTerm}
      />
    )
  }
}

export default Controller
